import type {
  CampaignOperationConfirmInput,
  CampaignOperationDetail,
  CampaignOperationHistory,
  CampaignOperationPreview,
  CampaignOperationPreviewInput,
  CampaignOperationProcessResult,
} from "@atsready/shared";
import { request } from "./api-client";

const base = "/campaign-email-operations";
export function previewCampaignEmail(
  id: string,
  input: CampaignOperationPreviewInput,
  signal?: AbortSignal,
) {
  return request<CampaignOperationPreview>(`/campaigns/${encodeURIComponent(id)}/email-preview`, {
    method: "POST",
    body: JSON.stringify(input),
    signal,
  });
}
export function confirmCampaignEmailOperation(
  id: string,
  input: CampaignOperationConfirmInput,
  signal?: AbortSignal,
) {
  return request<CampaignOperationDetail>(`${base}/${encodeURIComponent(id)}/confirm`, {
    method: "POST",
    body: JSON.stringify(input),
    signal,
  });
}
export function processCampaignEmailOperation(id: string, signal?: AbortSignal) {
  return request<CampaignOperationProcessResult>(`${base}/${encodeURIComponent(id)}/process-next`, {
    method: "POST",
    signal,
  });
}
export function retryCampaignEmailOperation(id: string, signal?: AbortSignal) {
  return request<CampaignOperationDetail>(`${base}/${encodeURIComponent(id)}/retry-failed`, {
    method: "POST",
    signal,
  });
}
export function reconcileCampaignEmailOperation(
  id: string,
  recipientId: string,
  signal?: AbortSignal,
) {
  return request<CampaignOperationProcessResult>(`${base}/${encodeURIComponent(id)}/reconcile`, {
    method: "POST",
    body: JSON.stringify({ recipientId }),
    signal,
  });
}
export function listCampaignEmailOperations(
  params: { campaignId?: string; cursor?: string } = {},
  signal?: AbortSignal,
) {
  const query = new URLSearchParams(params).toString();
  return request<CampaignOperationHistory>(`${base}${query ? `?${query}` : ""}`, { signal });
}
export function getCampaignEmailOperation(id: string, cursor?: string, signal?: AbortSignal) {
  const query = cursor ? `?${new URLSearchParams({ cursor }).toString()}` : "";
  return request<CampaignOperationDetail>(`${base}/${encodeURIComponent(id)}${query}`, { signal });
}
